module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.91fc022.woff";